import { IdDescription } from '../../../tms-shared';

export interface SalesOrderLineQuickCreate {
  salesOrderLineId: string;
  salesOrderHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  supplierDescription: string;
  customerDescription: string;
  quantity: number;
  price: number;
  nextDayDelivery: boolean;
  deliveryDate: Date;
  customerLineRef: string;
  conversionQuantity: number;
  priceListQty: number;
  convertedQuantity: number;
  orderUnitOfMeasureId: string;
  orderUnitOfMeasureDescription: string;
  orderUnitOfMeasureShortDescription: string;
  unitOfMeasureId: string;
  priceListUnitOfMeasureId: string;
  priceListUnitOfMeasureDescription: string;
  priceListUnitOfMeasureShortDescription: string;
  inlineAllocation: boolean;
  clearanceProduct: string;
  cutPrice: boolean;
  currencyCode: string;
  standardRollLength: number;
  noOfItems: number;
  allocateFullRolls: boolean;
  holdStockAtProductLevel: boolean;
  availableStock: number;
  clearQuickCreate: boolean;
  showNoOfItems: boolean;
  customerPortal: boolean;
  showPurchaseContracts: boolean;
  autoCreatePurchaseOrder: boolean;
  productOldCode: string;
  composition: string;
  discountRate: number;
  bomProduct: string;
  customerDefinedQuantity: number;
  availableProductId: string;
  fabricProcessingFabricId: string;
  reservation: boolean;
  reservationExpiryDate: Date;
  returnableProduct: boolean;
  returnDate: Date;
  confirmed: boolean;

  availableProductIds: IdDescription[];
}
